module.exports = __webpack_public_path__ + "img/LP---Image-Placeholder---7.d0fb01d2.png";